import type { ThemeConfig } from 'antd';

// Дефолтная тема Ant Design — пустой объект.
// Отдельный модуль нужен для симметрии с md3.ts и удобства подмены.
export const antdTheme: ThemeConfig = {};
